import React from "react";
import App from "./App";
import ApolloClient from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createHttpLink } from "apollo-link-http";
import { ApolloProvider } from "@apollo/react-hooks";
import { setContext } from "apollo-link-context";
import { RoomProvider } from "./context";
import { BrowserRouter } from "react-router-dom";

const httpLink = createHttpLink({
  uri: "https://talanta-api.herokuapp.com/",
  //uri: "http://localhost:5000/",

});

const authLink = setContext(() => {
  const token = localStorage.getItem("jwtToken");
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default (
  <ApolloProvider client={client}>
   <RoomProvider>
     <BrowserRouter>
       <App />
    </BrowserRouter>
   </RoomProvider>,
  </ApolloProvider>
);
